import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as ThemeProvider2 } from "@mui/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import WarningDialog from "./components/commons/dialog/WarningDialog";
import { themeMui } from './components/styled/Theme';
import { VersionUpdateDialog } from "@accessinformatica/service-worker";
import colors from "./config/colors";
import "./index.css";
import { persistor, store } from "./redux/store/store";
import Routing from "./routes/Routing";
import { getBasePath } from "./utils/getBasePath";

const themeMuiTheme = createTheme(colors);
const basename = getBasePath();
const router = createBrowserRouter([
  {
    path: "*",
    element: <Routing />,
  },
], { basename });

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          <ThemeProvider2 theme={themeMuiTheme}>
            <ThemeProvider theme={themeMui}>
              <RouterProvider router={router} />
              <WarningDialog />
              <VersionUpdateDialog />
              <ToastContainer
                position="bottom-right"
                hideProgressBar
                theme="colored"
              />
            </ThemeProvider>
          </ThemeProvider2>
        </LocalizationProvider>
      </PersistGate >
    </Provider >
  );
};

export default App;
